 
  <section class="mt-3">
    <div class="container">
      <div class="row">
        <div class="col-md-8 offset-md-2">
          <div class="card-1">
            <div class="row">
              <div class="col-md-12">
                
                <div class="text-center">
                  <a class="view-h gary-t"> Transaction  Id # {{TransactionId}} </a>
                </div>  
                <div  >
                    <div class="col-md-12 text-right pt-3" *ngIf="isSubmitted">
                        <button type="button" class="blue-btn btn" id="checkStatus"
                            click="StatusCheck()">Check The Status
                        </button>
                    </div>
                        
                    <div class="row mb-3 mt-4" >

                        <div class="col-4 p-0">
                            <label>Response Text </label>
                        </div>
                        
                        <!-- <div class="col-7 p-0 view-text"> {{ResponseText}}</div> -->
                        <div class="col-7 p-0 view-text text-success" *ngIf="approve"> {{ResponseText}}</div>
                        <div class="col-7 p-0 view-text text-danger" *ngIf="decline"> {{ResponseText}}</div>
                        <div class="col-7 p-0 view-text text-warning" *ngIf="submit"> {{ResponseText}}</div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4 p-0"> <label>Amount</label> </div>
                        
                        <div class="col-7 p-0 view-textot"><span class="sans-font">{{currency}}</span> {{AuthorizedAmount}}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4 p-0"> <label>Transaction Amount</label> </div>
                        
                        <div class="col-7 p-0 view-textot"><span class="sans-font">{{currency}}</span> {{TransactionAmount }}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4 p-0"> <label>Request UniqueId</label> </div>
                        
                        <div class="col-7 p-0 view-textot"> {{RequestUniqueId }}</div>
                    </div>
                    <div class="row mb-3" *>
                        <div class="col-4 p-0"> <label>Surcharge Amount</label> </div>
                        
                        <div class="col-7 p-0 view-text"><span class="sans-font">{{currency}}</span> {{SurchargeAmount }}</div>
                    </div>
                   




                    <div class="row mb-3">
                        <div class="col-4 p-0"> <label>FeeAmount</label> </div>
                        
                        <div class="col-7 p-0 view-text"><span class="sans-font">{{currency}}</span> {{rFeeAmount }}</div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-4 p-0"> <label>GstPercentage</label> </div>
                        
                        <div class="col-7 p-0 view-text"><span class="sans-font">₹</span> {{rGstPercentage }}</div>
                    </div>


                    <div class="row mb-3">
                        <div class="col-4 p-0"> <label>GstAmount</label> </div>
                        
                        <div class="col-7 p-0 view-text"><span class="sans-font">₹</span> {{rGstAmount }}</div>
                    </div> -->


                    <div class="row mb-3">
                        <div class="col-4 p-0"> <label>Total FeeAmount</label> </div>
                        
                        <div class="col-7 p-0 view-text"><span class="sans-font">{{currency}}</span> {{rTotalFeeAmount }}</div>
                    </div>

               
                    <div class="row mb-3">
                        <div class="col-4 p-0" *ngIf="PaymentType == 'CreditCard' ||PaymentType == 'DebitCard'||PaymentType == 'PrepaidCard'">
                            <label>Card Number</label>
                        </div>
                        
                        <div class="col-7 p-0 view-text" *ngIf="PaymentType == 'CreditCard' ||PaymentType == 'DebitCard'||PaymentType == 'PrepaidCard'">{{First6Digit}}-XX-XXXX-{{Last4Digit}}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4 p-0">
                            <label>Transaction Type </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{TransactionType}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Payment Type </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{PaymentType}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Source </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text"> {{Source}}</div>

                    </div>

                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Transaction Date </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{TransactionDateTime | date:'dd/MM/yyyy'}}</div>
                    </div>




                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer FirstName</label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerFirstName}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer LastName</label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerLastName}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer Address </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerAddress}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer City </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerCity }}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer State </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerState}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer ZipCode </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerZipCode}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer Email</label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerEmailOne}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer ContactNo</label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerContactNo}}</div>
                    </div>

                    


                    <!-- <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>BatchNo </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{BatchNo}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>BatchDateTime </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{BatchDateTime | date:'dd/MM/yyyy'}}</div>
                    </div>

                    <div class="row mb-3">
                        <div class="col-4 p-0">
                            <label>Customer Id </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerId}}</div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-4  p-0"><label>Customer Notes </label> </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerNotes}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Invoice No </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{InvoiceNo}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer Email </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerEmail}}</div>
                    </div> -->
                    <!-- <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer Bill_Id </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerBill_Id}}</div>
                    </div>
                    <div class="row mb-3">

                        <div class="col-4 p-0">
                            <label>Customer Ship_Id </label>
                        </div>
                        
                        <div class="col-7 p-0 view-text">{{CustomerShip_Id}}</div>
                    </div> -->
                    <div *ngIf="isCardsTransactionDetails">
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Name on Card</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{NameonCard}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Expiry Date</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{ExpiryDate}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Cvv Response Code</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{CvvResponseCode}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Avs Response Code</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{AvsResponseCode}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Card Code Response Code</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{CardCodeResponseCode}}</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4 p-0">
                                <label>Card Level Result Code</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{CardLevelResultCode}}</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-4 p-0">
                                <label>Card Type</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{CardType}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Track Type</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{TrackType}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Processor Transaction No</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{ProcessorTransactionNo}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0"><label>Trace No</label> </div>
                            
                            <div class="col-7 p-0 view-text">{{TraceNo}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Transaction SqNo</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{TransactionSqNo}}</div>
                        </div>

                    </div>
                    <div *ngIf="isNbsTransactionDetails">
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Bank Name</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{BankName}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Bank Id</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{BankId}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Bank ReferenceNo</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{BankReferenceNo}}</div>
                        </div>

                        <!-- <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Sur zCharge</label>
                            </div>
                            <div class="col-1 p-0">:</div>
                            <div class="col-7 p-0 view-text">{{SurCharge}}</div>
                        </div> -->
                    </div>

                    <div *ngIf="isUPITransactionDetails">
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Mid</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{Mid}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Type</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{Type}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Customer Reference Id</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{CustomerReferenceId}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Customer Mobile No</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{CustomerMobileNo}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Npci Upi TrxnId</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{NpciUpiTrxnId}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Reference Id</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{ReferenceId}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Merchant Trxn ReferenceId</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{MerchantTrxnReferenceId}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Status Description</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{StatusDescription}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Amount</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{Amount| number : '1.2-2'}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Transaction Auth Date</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{TransactionAuthDate| date:'dd/MM/yyyy'}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>PayerVitual Address</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayerVitualAddress}}</div>
                        </div>
                        <div class="row mb-3 ">

                            <div class="col-4 p-0">
                                <label>Payer Account No</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayerAccountNo}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Payer Account Name</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayerAccountName}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Payer Ifsc</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayerIfsc}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Payee Vitual Address</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayeeVitualAddress}}</div>
                        </div>
                        <div class="row mb-3 ">

                            <div class="col-4 p-0">
                                <label>Payee Account No</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayeeAccountNo}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Payee Account Name</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayeeAccountName}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Payee Ifsc</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayeeIfsc}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Payee Adhaar</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{PayeeAdhaar}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Addition Field1</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{AdditionField1}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Addition Field2</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{AdditionField2}}</div>
                        </div>
                    </div>
                    <div *ngIf="isWalletTransactionDetails">
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Wallet Type</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{WalletType}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Mid</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{Mid}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Customer Mobile No</label>
                            </div>
                            
                            <div class="col-7 p-0 view-text">{{CustomerMobileNo}}</div>
                        </div>
                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>Source </label>
                            </div>
                            
                            <div class="col-7 p-0 view-text"> {{Source}}</div>

                        </div>

                        <div class="row mb-3">

                            <div class="col-4 p-0">
                                <label>PlatformId </label>
                            </div>
                            
                            <div class="col-7 p-0 view-text"> {{PlatformId}}</div>

                        </div>
                    </div>
                    <div class="row ">
                        <button   class="blue-btn btn" [routerLink]="['/pos']" >Back</button>
                    </div>
                    <!-- <div  class="row"><div><label>Authorized Amount</label></div><div>:</div><div> {{Amount| number : '1.2-2'}}</div></div>
        <div  class="row"><div><label>Response Code</label></div><div>:</div><div class="col-md-4">{{RText}}</div></div>
        <div  class="row"><div><label>Approval Code</label></div><div>:</div><div> {{ACode}}</div></div>
        <div  class="row"><div><label>Card Number</label></div><div>:</div><div class="col-md-4">{{AccountFirst6}}-XXXX-XXXX-{{AccountLast4}}</div></div>
        <div  class="row"><div><label> NameOnCard</label></div><div>:</div><div class="col-md-4">{{NameonCard}}</div></div>
        <div  class="row"><div><label>TransactionDateTime</label></div><div>:</div><div class="col-md-4">{{TransactionDateTime}}</div></div>
        <div  class="row"><div><label>Transaction Status</label></div><div>:</div><div><label class="label bg-c-red">{{TransactionStatus}}</label></div></div> -->
                    <!-- <div class="text-left pt-2" *ngIf="isRefundAmount">
                        <button type="button" class="damke_siteBtn" id="refundTransactions"
                            (click)="RefundTransaction()">Refund
                        </button>
                    </div> -->

                    <!-- <div class="text-right pt-2">
                        <button type="button" class="damke_siteBtn" id="unsettledTransactions"
                            [routerLink]="['/transactions/manage']">View Unsettled
                            Transactions</button>
                    </div> -->
                </div>  
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
 